import React from 'react';
import PropTypes from 'prop-types';
import ReactHtmlParser from 'react-html-parser';
import { Link } from 'react-router-dom';
import { FacebookShareButton } from 'react-share';


const PostItem = ({ title, slug, excerpt, date, image }) => {
  const months = ['Január', 'Február', 'Március', 'Április', 'Május', 'Június', 'Július', 'Augusztus', 'Szeptember', 'Október', 'November', 'December'];
  const dateObject = new Date(date);
  const dateString = `${dateObject.getFullYear()} ${months[dateObject.getMonth()]} ${dateObject.getDate()}.`;

  return (
    <div className="post-item--small">
      <div className="post-share-buttons">
        <FacebookShareButton url={`${window.location.origin}/blog/${slug}`}>
          <i className="fab fa-facebook-f"></i>
        </FacebookShareButton>
      </div>
      <Link to={`/blog/${slug}`}>
        <div className="image">
          <img src={image.medium_large || image.full} alt={title} className="h-100" />
        </div>
        <div className="data">
          <h1>{ReactHtmlParser(title)}</h1>
          <div className="first-paragraph">{ReactHtmlParser(excerpt.replace(' [&hellip;]', '...'))}</div>
          <div className="date">
            {dateString}
          </div>
        </div>
      </Link>
    </div>
  );
};


PostItem.propTypes = {
  title: PropTypes.string.isRequired,
  slug: PropTypes.string.isRequired,
  excerpt: PropTypes.string.isRequired,
  date: PropTypes.string.isRequired,
  image: PropTypes.string.isRequired
};


export default PostItem;


// WEBPACK FOOTER //
// ./src/components/Posts/PostItem.js